import { useEffect, useState } from "react";
import { Facebook, Instagram } from "lucide-react";
import { scrollToSection } from "./Nav";

const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SOCIALS = [
  { icon: Facebook, label: "Facebook", id: "facebook", href: "https://www.facebook.com/share/1EMDqPEqWp/?mibextid=wwXIfr" },
  { icon: Instagram, label: "Instagram", id: "instagram", href: "https://www.instagram.com/merdy_mokoko?stkn=MWNsZjZud2dycW5pbw%3D%3D&utm_source=qr" },
  { icon: TikTokIcon, label: "TikTok", id: "tiktok", href: "https://www.tiktok.com/@merdymokoko?_r=1&_t=ZS-9AK2GB84Dz7" },
];

const Footer = () => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const tick = () =>
      setTime(
        new Date().toLocaleTimeString("fr-CA", { timeZone: "America/Toronto", hour: "2-digit", minute: "2-digit", second: "2-digit" })
      );
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="border-t border-white/10 pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-16">
          <button
            onClick={() => scrollToSection("#accueil")}
            className="text-left font-display font-extrabold tracking-tight text-[15vw] sm:text-[16vw] lg:text-[10rem] leading-[0.85] whitespace-nowrap -ml-[0.04em] text-stroke hover:text-white transition-colors duration-700 select-none"
            data-testid="footer-signature"
          >
            MERDI
          </button>
          <div className="flex flex-col gap-3 lg:text-right">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Heure locale — Québec</p>
            <p className="font-mono text-2xl text-white tabular-nums" data-testid="footer-clock">{time}</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-white/10 pt-8">
          <p className="text-xs text-zinc-500 font-mono">© 2026 Merdi. Tous droits réservés.</p>
          <div className="flex items-center gap-3">
            {SOCIALS.map(({ icon: Icon, label, id, href }) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-blue-500 hover:-translate-y-0.5 transition-all duration-300"
                data-testid={`footer-social-${id}`}
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
